import { Flex, Loader } from "@fluentui/react-northstar";

const TypingIndicator = () => {
    return (
        <Flex
            gap="gap.small"
            vAlign="center"
            styles={{
                padding: "10px 16px",
                backgroundColor: "#F3F2F1",
                borderRadius: "8px",
                marginBottom: "12px",
                maxWidth: "70%",
            }}
        >
            <Loader
                size="smallest"
                label="Génération en cours ..."
                labelPosition="end"
            />
        </Flex>
    );
};

export default TypingIndicator;
